<!--
 * @version: V1.0.0
 * @Date: 2023-08-14 16:25:54
 * @LastEditors: lzq
 * @LastEditTime: 2024-01-02 16:30:51
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\views\system\custom\components\addOrEdit.vue
 * @Descripttion:
-->
<!--  -->
<template>
  <el-drawer v-loading.fullscreen="loading" :visible="visible" size="70%" :destroy-on-close="true"
    :wrapper-closable="false" :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">

    <div slot="title" style="display: flex;justify-content: space-between">
      <div>
        {{ customInfo.id ? '编辑客户' : '新增客户' }}
      </div>
      <div>
        <el-button type="primary" @click="submit"> 保存 </el-button>
        <el-button @click="$emit('close')">取 消</el-button>
      </div>

    </div>
    <el-form ref="form" :rules="rules" :model="form" label-width="140px">
      <div class="box-title">客户信息</div>
      <el-form-item label="客户名称" prop="customer">
        <el-input v-model="form.customer" style="width: 360px" maxlength="20" placeholder="请输入客户名称"></el-input>
      </el-form-item>
      <el-form-item label="客户联系人" prop="customerName">
        <el-input v-model="form.customerName" style="width: 360px" maxlength="20" placeholder="请输入客户联系人"></el-input>
      </el-form-item>
      <el-form-item label="客户地址" prop="customerAddress">
        <el-input v-model="form.customerAddress" style="width: 360px" maxlength="100" placeholder="请输入客户地址"></el-input>
      </el-form-item>
      <div class="box-title">收件地址</div>
      <div style="margin-top: 8px;">
        <div v-for="(domain, index) in form.customerRecipientBoList" :key="domain.key" class="container">
          <i class="el-icon-error red remove" @click="handleDelete(index)"></i>
          <el-form-item label="收件人姓名" :prop="`customerRecipientBoList.${index}.name`" :rules="rules.name">
            <el-input v-model="domain.name" style="width: 80%" maxlength="20" placeholder="请输入收件人姓名"></el-input>
          </el-form-item>
          <el-form-item label="收件人区域" :prop="`customerRecipientBoList.${index}.recipientArea`"
            :rules="rules.recipientArea">
            <el-cascader v-model="domain.recipientArea" style="width: 80%" :props="{ checkStrictly: true, value: 'label' }"
              :options="regionData" />
          </el-form-item>
          <el-form-item label="收件人详细地址" :prop="`customerRecipientBoList.${index}.address`" :rules="rules.address">
            <el-input v-model="domain.address" style="width: 80%" maxlength="100" placeholder="请输入收件人详细地址"></el-input>
          </el-form-item>
          <el-form-item label="收件人电话" :prop="`customerRecipientBoList.${index}.telephone`" :rules="rules.telephone">
            <el-input v-model="domain.telephone" style="width: 80%" maxlength="100" placeholder="请输入收件人电话"></el-input>
          </el-form-item>
        </div>
        <div style="width: 100%;text-align: center;">
          <el-button type="text" @click="handleAdd">
            <i class="el-icon-plus"></i>新增收件人
          </el-button>
        </div>

      </div>

    </el-form>

  </el-drawer>
</template>

<script>
import { customerRecipientRemove, deleteCustom, saveOrUpdateCustom } from "@/api/system/custom";
import { regionData } from 'element-china-area-data'
import { getCustomInfo } from '@/api/system/custom'
import { findNode } from '@/utils/ruoyi'

export default {
  name: 'AddOrEditCustom',
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      }
    },
    customInfo: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data() {
    // 这里存放数据
    return {
      loading: false,
      regionData,
      form: {
        customer: null,
        customerName: null,
        customerAddress: null,
        customerRecipientBoList: [{
          telephone: null,
          name: null,
          recipientArea: null,
          address: null,
          key: Math.random()
        }]
      },
      rules: {
        customer: [
          {
            required: true,
            message: '请输入客户名称',
            trigger: ['change', 'blur']
          }
        ],
        customerName: [
          {
            required: true,
            message: '请输入客户联系人',
            trigger: ['change', 'blur']
          }
        ],
        customerAddress: [
          {
            required: true,
            message: '请输入客户地址',
            trigger: ['change', 'blur']
          }
        ],
        name: [
          {
            required: true,
            message: '请输入收件人姓名',
            trigger: ['change', 'blur']
          }
        ],
        recipientArea: [
          {
            required: true,
            message: '请选择收件人区域',
            trigger: ['change', 'blur']
          }
        ],
        telephone: [{
          required: true,
          message: '请输入收件人电话',
          trigger: ['change', 'blur']
        }, {
          pattern: /^(?:(?:\+?86)?1[3-9]\d{9}|0[1-9]\d{1,2}-?\d{7,8})$/,
          message: '请输入正确的电话格式',
          trigger: ['change', 'blur']
        }]
      }
    }
  },
  created() {
    if (this.customInfo.id) {
      this.getOrderInfo(this.customInfo.id)
    }
  },
  // 方法集合
  methods: {
    // 获取单据信息
    getOrderInfo(id) {
      // 获取基础信息数据
      this.loading = true
      getCustomInfo(id).then(res => {
        const {
          customerRecipientVoList
        } = res.data
        this.form = JSON.parse(JSON.stringify(res.data))
        customerRecipientVoList.forEach((item, index) => {
          // const list = ['provinceName', 'cityName', 'countyName']
          // const recipientArea = []
          // list.forEach(key => {
          //   const find = findNode(this.regionData, item[key], 'label')
          //   if (find) {
          //     recipientArea.push(find.value)
          //   }
          // }
          customerRecipientVoList[index].recipientArea = [item.provinceName, item.cityName, item.countyName]
          customerRecipientVoList[index].recipientAreaText = `${item.provinceName}/${item.cityName}/${item.countyName}`
          customerRecipientVoList[index].key = Math.random()
        })
        // 转换数据
        for (const key in this.form) {
          if (res.data[key]) {
            this.form[key] = res.data[key]
          }
        }
        this.$set(this.form, 'customerRecipientBoList', customerRecipientVoList)
      }).finally(() => {
        this.loading = false
      })
    },
    // 保存
    submit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        this.loading = true
        const params = JSON.parse(JSON.stringify(this.form));
        params.customerRecipientBoList.forEach((item) => {
          if (item.recipientArea) {
            // 省市区转换
            const [consigneeProvinceName, consigneeCityName, consigneeCountyName] = item.recipientArea
            // 省市区转换
            const provinceName = findNode(this.regionData, consigneeProvinceName)
            const cityName = findNode(this.regionData, consigneeCityName)
            const countyName = findNode(this.regionData, consigneeCountyName)
            // item.provinceName = provinceName ? provinceName.label : ''
            // item.cityName = cityName ? cityName.label : ''
            // item.countyName = countyName ? countyName.label : ''
            item.provinceName = consigneeProvinceName
            item.cityName = consigneeCityName
            item.countyName = consigneeCountyName
            delete item.recipientArea
          }
        })


        saveOrUpdateCustom(params).then(() => {
          this.$emit('close')
        }).finally(() => {
          this.loading = false

        })
      })
    },
    handleDelete(index) {
      this.$confirm('您确定要删除当前地址？', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true // 打开遮罩
        if (this.form.customerRecipientBoList[index].id) {
          customerRecipientRemove(this.form.customerRecipientBoList[index].id).then(res => {
            this.form.customerRecipientBoList.splice(index, 1);
            this.$message.success('删除成功')
          }).finally(() => {
            this.loading = false // 关闭遮罩
          })
        } else {
          this.loading = false // 关闭遮罩
          this.$message.success('删除成功')
        }
      })
    },
    handleAdd() {
      this.form.customerRecipientBoList.push({
        telephone: null,
        name: null,
        recipientArea: null,
        address: null,
        key: Math.random()
      })
    },
  }
}
</script>

<style scoped lang="scss">
.container {
  padding: 12px 8px;
  background: #F2F2F2;
  position: relative;
  width: 60%;
  margin: 0 12px 12px;

  .remove {
    font-size: 20px;
    z-index: 999;
    position: absolute;
    cursor: pointer;
    top: 4px;
    right: 5px;
  }

}
</style>
